<template>
  <v-dialog
    v-model="_active"
    @click:outside="false"
    :fullscreen="showMobileView"
    :width="showMobileView ? '' : '600'"
    persistent
  >
    <v-card id="key-edit-dialog">
      <v-card color="primary" tile>
        <v-card-title class="py-0 white--text" color="primary">
          <v-container>
            <v-row>
              <v-spacer cols="2" />
              <v-col cols="8" class="pb-0">
                <v-card-text
                  class="text-center text-subtitle-1 font-weight-medium pb-0"
                  id="edit-digital-key"
                >
                  Edit Digital Key
                </v-card-text>
              </v-col>
              <v-col cols="2" class="pb-0 pt-5">
                <v-btn color="white" text @click="_setActive(false)">
                  <v-icon xl>mdi-close</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-title>
      </v-card>
      <div class="px-4 mt-8">
        <v-text-field
          label="Email Address"
          id="key-edit-email"
          filled
          @input="changed = true"
          dense
          v-model="email"
        ></v-text-field>
        <v-text-field
          label="Phone Number"
          filled
          id="key-edit-phone"
          dense
          @input="changed = true"
          :rules="phoneRules"
          v-model="phone"
        ></v-text-field>
        <v-menu
          v-model="returnMenu"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          max-width="290px"
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              filled
              v-model="returnDate"
              label="Return Date"
              append-icon="mdi-calendar-blank"
              id="key-edit-date"
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="returnDate"
            no-title
            @input="dateChange()"
          ></v-date-picker>
        </v-menu>
        <v-row>
          <v-spacer />
          <v-btn
            @click="editKey()"
            color="primary"
            width="170"
            :disabled="!changed"
            height="40"
            id="key-edit-button"
          >
            Edit Key
          </v-btn>
          <v-spacer />
        </v-row>
        <v-row>
          <v-spacer />
          <v-btn
            @click="cancel()"
            text
            class="primary--text"
            height="40"
            width="170"
            id="key-cancel"
          >
            Cancel
          </v-btn>
          <v-spacer />
        </v-row>
      </div>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapGetters, mapMutations, mapActions } from 'vuex';
import moment from 'moment';
import MobileView from '@/mixins/MobileView';

export default {
  mixins: [MobileView],
  data() {
    return {
      returnMenu: false,
      email: '',
      phone: '',
      returnDate: '',
      changed: false,
      phoneRules: [
        (v) => /^\d+$/.test(v) || 'Phone number must have digits only.',
        (v) => v.toString().length <= 10 || 'Phone number may not exceed 10 digits',
        (v) => v.toString().length > 9 || 'Phone number is not long enough.',
      ],
    };
  },
  computed: {
    ...mapGetters({
      _active: 'digitalKeyDetails/getEditKey',
      _details: 'digitalKeyDetails/getDetails',
    }),
    payload() {
      return {
        email: this.email.toLowerCase(),
        phone: this.phone,
        expected_return: moment.valueOf(this.returnDate),
        uuid: this._details.uuid,
      };
    },
  },
  methods: {
    ...mapMutations({
      _setActive: 'digitalKeyDetails/setEditKey',
    }),
    ...mapActions({
      _editKey: 'digitalKeyDetails/editKey',
      _acquireData: 'digitalKeyDetails/acquireDetails',
    }),
    editKey() {
      this._editKey(this.payload).then(() => {
        this._setActive(false);
      });
    },
    cancel() {
      this._setActive(false);
      this.changed = false;
    },
    dateChange() {
      this.changed = true;
      this.returnMenu = false;
    },
  },
  watch: {
    _active() {
      this.email = this._details.email;
      this.phone = this._details.phone;
      this.returnDate = new moment(this._details.expected_return * 1000).format(
        'YYYY-MM-DD',
      );
    },
  },
};
</script>
